import { render, staticRenderFns } from "./DonutBreath.vue?vue&type=template&id=dd691542&"
import script from "./DonutBreath.vue?vue&type=script&lang=js&"
export * from "./DonutBreath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports